const collection = {
    slug: "dior-homme-hedi-slimane-archive-guide",
    metaTitle:
      "Dior Homme エディスリマン期とは｜細身パンツ再評価とDiorアーカイブ完全ガイド",
    metaDescription:
      "Dior Hommeのエディスリマン期を知りたい方へ。2000年代メンズファッションを変えた細身シルエット、ロック、少年性、神経質な身体像、Karl Lagerfeldの減量逸話、近年の細身パンツ再評価まで解説。Dior Hommeを入口に、Dior全般のアーカイブ価値とEnclopediaのレンタル・買取サービスを知るための完全ガイドです。",
    metaKeywords:
      "Dior Homme エディスリマン期,Dior Homme Hedi Slimane,ディオールオム エディ期,エディスリマン Dior Homme,Dior Homme アーカイブ,ディオールオム アーカイブ,Dior Homme スキニー,Dior Homme 細身パンツ,Dior Homme 2000年代,Dior 買取,Dior Homme 買取,ディオール 買取,ディオールオム 買取,Dior アーカイブ 買取,Dior Men 買取,Christian Dior 買取,Hedi Slimane Dior Homme,細身パンツ トレンド,スキニーパンツ トレンド,Enclopedia,アンクロペディア",
    canonicalPath: "/archive_collection/dior-homme-hedi-slimane-archive-guide",
    heroImage: "media/archive_fashion/archive5.png",
    heroImageAlt:
      "Dior Homme エディスリマン期の細身シルエットとDiorアーカイブ価値を解説するEnclopediaガイド画像",
    heroNumber: "05 / HEDI ERA",
    label: "ARCHIVE BRAND GUIDE",
    title: "Dior Homme エディ・スリマン期とは",
    lead:
      "細身のパンツが、また戻ってきている。\nでも、Hedi SlimaneがDior Hommeで作った“細さ”は、ただシルエットを細くしただけではありませんでした。\nそこにはロック、少年性、神経質さ、そしてそれまでの男性服とは違う身体像がありました。\nワイドシルエットが長く続いた今だからこそ、Dior Hommeのエディ期をアーカイブとして読み直す意味があります。\nこの記事は、Dior Hommeを入口に、Enclopediaがアーカイブファッションをどのように読み、レンタルや買取を通じて次のユーザーへつなげるサービスなのかを知るためのページです。",
    keywordLine: [
      "hedi slimane",
      "dior homme",
      "skinny silhouette",
      "dior archive",
    ],
    thesis:
      "Dior Hommeのエディ・スリマン期が今も評価される理由は、細身の服を作ったからではなく、男性の理想体型とムードそのものを変えたからです。",
    whyTitle:
      "細身パンツの復活は、ただの反動なのか。",
    whyBody:
      "ここ数年、ファッションの中心にはワイドパンツ、バギーデニム、オーバーサイズのジャケットがありました。\nしかし現在、スリムフィットや細身のパンツが再び注目され始めています。\nただし、それを単なる“ワイドの反動”として見るだけでは浅い。\nHedi SlimaneがDior Hommeで提示した細さは、脚を細く見せるためのシルエットではなく、ロックバンドの少年、痩せた身体、神経質なムード、黒いジャケット、細いデニム、低い重心が一体になった文化でした。\nだからこそ、エディ期Dior Hommeのアーカイブは今も単なる古い服ではなく、2000年代の男性像を変えた資料として再評価されています。\nEnclopediaでは、このような文脈を入口に、Dior HommeだけでなくDior全般のアーカイブ価値を読み取り、レンタルや買取を通じて次のユーザーへつなげます。",
    pillars: [
      {
        number: "01",
        title: "SKINNY AS CULTURE",
        text:
          "エディ・スリマンの細さは、単なるサイズ感ではありません。ロック、インディー、少年性、退廃感が重なった文化的な身体像として機能しました。",
      },
      {
        number: "02",
        title: "BODY IDEAL SHIFT",
        text:
          "Dior Homme以降、男性服の理想は、逞しさや威厳だけではなく、細く、鋭く、神経質な身体へと大きく振れました。",
      },
      {
        number: "03",
        title: "DIOR ARCHIVE ENTRY",
        text:
          "エディ期Dior Hommeは、Diorアーカイブを知るための強い入口です。ただしEnclopediaが見ているのはエディ期だけではなく、Dior全般の時代性と価値です。",
      },
    ],
    readingTitle:
      "エディ期Dior Hommeを、細さ・ロック・身体像から読む。",
    readingIntro:
      "Dior Hommeのエディ期を理解するうえで重要なのは、“細い服”という結果だけを見ることではありません。その細さが、どんな音楽、どんな身体、どんな男性像と結びついていたのかを見ることです。",
    observations: [
      {
        index: "01",
        title: "細いパンツは、脚を細く見せるためだけではなかった",
        text:
          "Dior Hommeの細身パンツは、単にスキニーという形ではなく、ジャケット、ブーツ、シャツ、髪型、音楽のムードと接続されていました。\n脚の細さは、身体全体の緊張感を作るための装置でした。\nEnclopedia視点：細身パンツやスキニーデニムを見るときは、単なる古いシルエットではなく、当時の身体像やスタイリング全体の中で評価します。",
      },
      {
        index: "02",
        title: "ロックは装飾ではなく、身体の態度だった",
        text:
          "エディ・スリマンのDior Hommeには、ロックの直接的な引用だけでなく、ステージに立つ身体、夜の街にいる身体、細く鋭い緊張感がありました。\nそれはレザージャケットやスキニーデニムだけでなく、スーツの肩、パンツの細さ、シャツの薄さにも表れます。\nEnclopedia視点：レザー、テーラード、デニム、ブーツなどは、単体の人気だけでなく、エディ期らしいスタイルがどれだけ残っているかを見ます。",
      },
      {
        index: "03",
        title: "少年性と神経質さが、男性服の理想を変えた",
        text:
          "従来の男性服が、逞しさ、落ち着き、社会性を強調していたとすれば、エディ期Dior Hommeはそれとは別の男性像を提示しました。\n細く、若く、少し不安定で、神経質な身体。\nその身体像が、2000年代以降のメンズファッションに大きな影響を与えました。\nEnclopedia視点：小さいサイズや細身のサイズ感でも、エディ期らしさが強いものは現在の需要と合わせて確認します。",
      },
      {
        index: "04",
        title: "Karl Lagerfeldの減量逸話が象徴するもの",
        text:
          "Karl LagerfeldがDior Hommeを着るために身体を絞ったという逸話は、単なる有名人エピソードではありません。\nそれだけDior Hommeの服が、着る側の身体そのものを変えさせるほどの強度を持っていたという象徴です。\nEnclopedia視点：エディ期のスーツやジャケットは、単なるDiorの古着ではなく、身体像を変えた時代のアーカイブとして見ます。",
      },
      {
        index: "05",
        title: "ワイドの時代を経た今、なぜ細さが戻るのか",
        text:
          "ワイドパンツやオーバーサイズは、身体を隠し、余白を作る服でした。\n一方で細身のパンツは、身体の線、緊張感、スタイリングの鋭さをはっきり出します。\n今の細身回帰は、単なる反動というより、長く続いたワイドシルエットの後に、もう一度“身体の輪郭”を見直す動きとも言えます。\nEnclopedia視点：細身シルエットの再評価が進むほど、Dior Hommeのエディ期はDiorアーカイブを読む入口としてさらに分かりやすくなります。",
      },
      {
        index: "06",
        title: "エディ期Dior Hommeは、流行ではなく文化として残った",
        text:
          "トレンドを追うだけなら、“また細身が来た”で終わります。\nしかしアーカイブとして見ると、その細さがなぜ人を惹きつけたのか、どんな感情や身体像をまとっていたのかまで見えてきます。\nだからこそ、エディ期Dior Hommeは現在も古着市場やアーカイブ文脈で語られ続けています。\nEnclopedia視点：このページはエディ期だけを切り取るためではなく、Dior全体をアーカイブとして読み直す入口です。",
      },
    ],
    quote:
      "Hedi Slimaneが作った細さは、服の幅ではなく、男性の身体像そのものを変えた。",
    perspectiveTitle:
      "Enclopediaは、Dior Hommeを“古着”ではなく“時代を変えたアーカイブ”として読む。",
    perspectiveCards: [
      {
        number: "01",
        title: "KNOWLEDGE",
        text:
          "Dior Hommeのエディ期を、スキニー、ロック、少年性、神経質な身体像という文脈から整理します。単なるブランド紹介ではなく、なぜ今も語られるのかを見せます。",
      },
      {
        number: "02",
        title: "SERVICE ENTRY",
        text:
          "この記事は、Dior Hommeだけでなく、Enclopediaがアーカイブファッションをどのように読み、扱い、次のユーザーへつなげるサービスなのかを知ってもらう入口です。",
      },
      {
        number: "03",
        title: "DIOR BUYBACK",
        text:
          "買取対象はエディ期Dior Hommeに限定しません。Dior Homme、Dior Men、Christian Dior、John Galliano期、Kim Jones期など、Dior全般を相談対象として見ます。",
      },
    ],
    experienceTitle:
      "Diorを売る前に、その一着がどの文脈にあるかを確認する。",
    experienceBody:
      "Diorの買取では、ブランド名だけでなく、ライン、年代、デザイナー、シルエット、状態、現在の需要が重要です。\n今回の記事ではHedi Slimane期のDior Hommeを中心に解説していますが、Enclopediaが見ているのはエディ期だけではありません。\nChristian Dior、Dior Homme、Dior Men、John Galliano期、Hedi Slimane期、Kim Jones期など、Dior全般を対象に、その一着がどの時代のどんな価値を持つのかを確認します。\n細身シルエットが再び注目されている今、Dior Hommeのエディ期は特に分かりやすい入口ですが、最終的にはDiorというブランド全体のアーカイブ価値を見て買取相談へつなげます。",
    experienceItems: [
      "Dior / Dior Homme / Dior Menなどライン名を確認する",
      "タグ・品質表示・年代・デザイナー期が分かる写真を撮影する",
      "Hedi Slimane期と思われる細身パンツ、ジャケット、デニム、レザーを確認する",
      "John Galliano期やKim Jones期など、他のDiorアーカイブも相談する",
      "サイズ・状態・裾上げ有無・付属品を確認する",
      "エディ期か不明な場合もLINEで写真を送る",
    ],
    archiveItemsTitle:
      "Dior Hommeを入口に、Dior全般の価値を相談する。",
    archiveItemsBody:
      "Enclopediaでは、Dior Hommeのエディ期だけを特別扱いするのではなく、Dior全般をアーカイブファッションの文脈で見ています。この記事でDior Hommeの細身シルエットや時代性に興味を持った方は、所有しているDiorの一着も、まずはLINEでご相談ください。",
    archiveItems: [
      {
        label: "BUYBACK FOCUS 01",
        title: "Dior買取ページへ",
        productPath: "/brand_buyback/dior",
        productImage: "",
        text:
          "Dior Homme、Dior Men、Christian Dior、Hedi Slimane期、John Galliano期、Kim Jones期まで。Dior全般の買取対象と査定視点を確認できます。",
      },
      {
        label: "BUYBACK FOCUS 02",
        title: "LINEでDiorを事前査定",
        productPath: "https://line.me/R/ti/p/@240yzqkh",
        productImage: "",
        text:
          "タグ、品質表示、全体写真、ディテール写真を送るだけで、宅配買取へ進む前におおまかな査定方向を確認できます。エディ期か分からない場合も相談可能です。",
      },
      {
        label: "SERVICE FOCUS 03",
        title: "Enclopediaのアーカイブレンタルを見る",
        productPath: "/",
        productImage: "",
        text:
          "Enclopediaは買取だけでなく、アーカイブを次の人が体験できるレンタルサービスです。服を所有物ではなく、文化として循環させます。",
      },
    ],
    finalCta: {
      title:
        "Dior Hommeの記事を読んだら、次はEnclopediaでDiorの価値を相談する。",
      body:
        "エディ期Dior Hommeは、Diorアーカイブを知るための強い入口です。\nただし、Enclopediaが見ているのはエディ期だけではありません。\nDior Homme、Dior Men、Christian Dior、John Galliano期、Kim Jones期まで、Dior全般の価値をアーカイブの視点で確認します。\nまずはLINEでタグ・品質表示・全体写真をお送りください。",
      buttonLabel: "DiorをLINEで事前査定する",
      buttonHref: "https://line.me/R/ti/p/@240yzqkh",
    },
  };

export default collection;
